import React, {Component} from 'react';

export default class SelectExtras extends Component {
    constructor(props) {
        super(props);

        this.checkDefaultValue = this.checkDefaultValue.bind(this);
        this.handleSelectExtraQty = this.handleSelectExtraQty.bind(this);

        this.state = {
            selected_extras: []
        }

    }

    checkDefaultValue(extra) {
        let selected_extras = [...this.state.selected_extras];
        let updateable = selected_extras.find((item) => item.id === extra.id);

        if (updateable) {
            return updateable.qty;
        } else {
            return '';
        }
    }

    handleSelectExtraQty(event, extra) {
        let extras = [...this.props.extras];
        let selected_extras = [...this.state.selected_extras];

        let updateable = extras.find((item) => item.id === extra.id);

        let selected = selected_extras.find((item) => item.id === extra.id);

        if (!selected) {
            selected_extras.push({
                ...updateable,
                total_price: event.target.value * updateable.price_per_item,
                qty: event.target.value
            });
        }

        if (selected) {
            let index = selected_extras.indexOf(selected);
            selected_extras.splice(index, 1);

            if (event.target.value != '0') {
                selected_extras.push({
                    ...selected,
                    total_price: event.target.value * selected.price_per_item,
                    qty: event.target.value
                });
            }
        }

        this.setState({
            extras: extras,
            selected_extras: selected_extras
        });

        this.props.updateParentState('extras', selected_extras)
    }

    displayTotal(extra) {
        let selected_extras = [...this.state.selected_extras];
        let updateable = selected_extras.find((item) => item.id === extra.id);

        if (updateable) {
            return updateable.total_price;
        } else {
            return '0';
        }
    }

    render() {
        return (
            <div>
                <div className="row justify-content-center pb-3">
                    <div className="col-md-10 justify-content-center">
                        <h2 className="text-center wizard-heading pt-sm-0 pt-5">Any extras?</h2>
                        <p className="py-3">We make additional charges for these items because we ourselves have to pay extra for their recycling.</p>
                    </div>
                </div>
                {this.props.extras.map((extra) => {
                    return (
                        <div className="row justify-content-center my-1" key={extra.id}>
                            <div className="col-md-10">
                                <div className="card">
                                    <div className="card-body card-wizard">
                                        <div className='row'>
                                            <div className='col-md-2 col-6 order-2 order-md-1'>
                                                <select name={extra.name} value={this.checkDefaultValue(extra)}
                                                        className='form-control'
                                                        onChange={(event) => this.handleSelectExtraQty(event, extra)}>
                                                    {Array(extra.max_quantity + 1).fill().map((index, number) => {
                                                        return (
                                                            <option
                                                                key={number}
                                                                value={number}
                                                            >
                                                                {number}
                                                            </option>
                                                        )
                                                    })};
                                                </select>
                                            </div>
                                            <div
                                                className='col-md-8 d-flex align-items-center order-1 order-md-2 mb-2'>
                                                <p style={{marginBottom: '0', color: '#FDB913'}}>{extra.name}</p>
                                            </div>
                                            <div className='col-md-2 col-6 order-3 order-md-3'>
                                                <div style={{
                                                    border: '1px solid rgba(0,0,0,.125)',
                                                    borderRadius: '4px',
                                                    padding: '.375rem .75rem',
                                                    backgroundColor: '#fff'
                                                }}>
                                                    &#163;<span>
                                                        {/*{this.state.extras[index].total_price || '0'} */}
                                                    {this.displayTotal(extra)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        );
    }
}
